import { Stream } from '@/__generated__/schema-types';

export const isMatchingStream = (
  stream: Pick<Stream, 'polymatcherEnabled'>,
): boolean => stream.polymatcherEnabled;

/** A list is usable for market-matched news as soon as one source matches. */
export const hasMatchingStream = (
  streams: Array<Pick<Stream, 'polymatcherEnabled'>>,
): boolean => streams.some(isMatchingStream);

export const isSmartNewsStream = (
  stream: Pick<Stream, 'id' | 'polymatcherEnabled'>,
  tier1StreamIds: ReadonlySet<string>,
): boolean => isMatchingStream(stream) || tier1StreamIds.has(stream.id);
